@if (showLanguageSelect()) {
  <ds-select [formControl]="langControl" [clearable]="false">
    <ds-select-text>
      {{ selectedLabel() }}
    </ds-select-text>

    @for (it of items(); track it.lang) {
      <ds-select-option [value]="it.lang">
        {{ (it.label).toUpperCase() }}
      </ds-select-option>
    }
  </ds-select>
}
